<template>
  <v-footer style="background-color:transparent;">
    <v-tooltip top>
      <template v-slot:activator="{ on }">        
        <v-btn
          icon
          small
          @click="changeLanguage('pt_BR')"
          class="mt-2 mr-0"
          v-on="on"
        >
          <img src="/static/img/brazil_icon_flag.svg" height="26" width="26">
        </v-btn>
      </template>
      <span>Português</span>
    </v-tooltip>        
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          icon 
          small 
          @click="changeLanguage('en_US')"
          class="mt-2 mr-0"
          v-on="on"
        >
          <img src="/static/img/usa_icon_flag.svg" height="26" width="26">
        </v-btn>
      </template>
      <span>English</span>
    </v-tooltip>                
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn 
          icon 
          small 
          @click.native="changeLanguage('es_ES')"
          class="mt-2 mr-2"
          v-on="on"
        >
          <img src="/static/img/spain_icon_flag.svg" height="26" width="26">
        </v-btn>    
      </template>
      <span>Español</span>
    </v-tooltip> 
  </v-footer>
</template>

<script>
export default {
  methods: {
    changeLanguage(language) {
      this.$i18n.locale = language;
      this.$store.dispatch("setLanguage", language);
    }
  }
};
</script>

<style>
.some-margin {
  margin-top: 8px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue